import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 15px;
  padding-bottom: 20px;
`;
